import React, { useState } from 'react';

import BusinessCardCarousel from 'components/BusinessCardCarousel/BusinessCardCarousel';
import Headline from 'components/Headline/Headline';
import Overlay from 'components/Overlay/Overlay';
import PersonTile from 'components/PersonTile/PersonTile';
import RichText from 'components/RichText/RichText';
import useOverElement from 'hooks/useOverElement';
import { setCursorLabel, triggerMoveMeCursor } from 'utils/cursorController';
import { handleMouseLeave } from 'utils/cursorGlobal';
import { CMSLeadershipSection } from 'utils/sharedStrapiQueries/sharedTypes';

import * as S from '../AboutPage.styles';

const LeadershipSection: React.FunctionComponent<CMSLeadershipSection> = ({
  animatedHeader,
  cards,
  sectionTitle,
  description,
  linkedInLabel,
}) => {
  const [personOverlay, setPersonOverlay] = useState<number | undefined>();

  const [ref] = useOverElement();

  const handleMouseEnter = () => {
    setCursorLabel('Move me');
    triggerMoveMeCursor();
  };

  const renderCards = cards.map((card, index) => (
    <S.CardWrapper key={card.id} onClick={() => setPersonOverlay(index)}>
      <PersonTile {...card} />
    </S.CardWrapper>
  ));

  return (
    <>
      {animatedHeader && (
        <S.AboutInfiniteSlider>
          <S.AnimatedHeaderText text={animatedHeader} size="display" />
        </S.AboutInfiniteSlider>
      )}

      <S.LeadershipSectionWrapper ref={ref}>
        <S.LeadershipInfo>
          <Headline text={sectionTitle} size="heading2" />
          {description && (
            <RichText
              as="p"
              size="smallBody"
              richText={description}
              defaultFormatting
            />
          )}
        </S.LeadershipInfo>

        <S.Slider>
          <S.LeadershipSliderContent
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            {renderCards}
          </S.LeadershipSliderContent>
        </S.Slider>
        <Overlay
          isOpen={personOverlay !== undefined}
          onExitClick={() => setPersonOverlay(undefined)}
          withSpacing
          animation="fade"
          delay={0}
        >
          <BusinessCardCarousel
            linkedInLabel={linkedInLabel}
            people={cards}
            id={personOverlay}
            heading={sectionTitle}
          />
        </Overlay>
      </S.LeadershipSectionWrapper>
    </>
  );
};

export default LeadershipSection;
